export default "__VITE_ASSET__MLTlHs3s__"